/**
 * all ado credit eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { GetCreditPanInformationResponse } from '../model/getCreditPanInformationResponse';
import { Type } from '../model/type';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class CreditApiService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1 概要 パーソナライズ情報から取得したDGFT会員ID、DGFTカードIDを基にクレジット情報取得用パラメータをsAPIに渡し、クレジットカード情報をレスポンスとして受け取る。  # 2 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。&lt;br/&gt;     &amp;emsp;※以下の提携IF定義書に従い、必須、文字種、桁数チェックを行う。&lt;br/&gt;     &amp;emsp;■提携IF定義書&lt;br/&gt;       &amp;emsp;&amp;emsp;ファイル名：【他システムIF】提携IF定義書(全社サマリ)_01_対提携・クレジット関連.xlsx&lt;br/&gt;       &amp;emsp;&amp;emsp;シート名：クレジットカードPAN情報取得（DGFT）&lt;br/&gt;    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにて、アクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     &amp;emsp;有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。    1. DGFT会員ID、DGFTカードIDを取得する。     1. パーソナライズ情報.ユーザ共通情報.ANA Bizログインステータスが「LOGIN：ログイン済」の場合       1. 以下の内容でAegis_クレジットカードCVV情報取得のsAPIを呼び出し、ペイロードされたJSON形式のクレジットカードCVV情報を取得する。&lt;br/&gt;     &amp;emsp;&amp;emsp;HTTPメソッド：POST&lt;br/&gt;     &amp;emsp;&amp;emsp;URL：/get-cvvinfo&lt;br/&gt;     &amp;emsp;&amp;emsp;パラメータ：パーソナライズ情報から取得した企業ID、ログインユーザーIDを基にJSON形式でリクエスト情報を作成し、sAPIのリクエストボディに設定&lt;br/&gt;       1. 取得したクレジットカードCVV情報について、提携IF定義書に従い、必須、文字種、桁数チェックを行う。&lt;br/&gt;     &amp;emsp;&amp;emsp;エラーが発生している場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。&lt;br/&gt;       1. クレジットカードCVV情報から、DGFT会員ID、DGFTカードIDを取得し、変数に格納する。     1. 上記以外の場合       1. パーソナライズ情報からDGFT会員ID、DGFTカードIDを取得し、変数に格納する。   1. 以下の内容でDGFT_クレジットカードPAN情報取得のsAPIを呼び出し、ペイロードされたJSON形式のクレジットカード情報を取得する。&lt;br/&gt;     &amp;emsp;HTTPメソッド：POST&lt;br/&gt;     &amp;emsp;URL：/get-cardinfo&lt;br/&gt;     &amp;emsp;パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、sAPIのリクエストボディに設定&lt;br/&gt;     &amp;emsp;※ADOについてはDGFT会員ID、DGFTカードIDをパラメータとして渡す。&lt;br/&gt;     &amp;emsp;また、登録されたカードIDの件数分、sAPIを呼び出しクレジットカード情報を取得する。   1. 取得したクレジットカード情報について、提携IF定義書に従い、必須、文字種、桁数チェックを行う。&lt;br/&gt;     &amp;emsp;エラーが発生している場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。    1. レスポンスエラーが返却された場合、以下の提携IF定義書に従い、エラーコードに応じてエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     &amp;emsp;■提携IF定義書&lt;br/&gt;       &amp;emsp;&amp;emsp;ファイル名：【他システムIF】提携IF定義書(全社サマリ)_01_対提携・クレジット関連.xlsx&lt;br/&gt;       &amp;emsp;&amp;emsp;シート名：【別添】エラーコード一覧（DGFT）&lt;br/&gt;    1. ALLDB(Tx)のパーソナライズ情報の会員情報にクレジットカード情報を登録する。     1. パーソナライズ情報.ユーザ共通情報.ANA Bizログインステータスが「LOGIN：ログイン済」の場合       1. 法人用クレジットカード情報にクレジットカード番号、有効期限、CVVを設定する。     1. 上記以外の場合       1. 一般用クレジットカード情報にクレジットカード番号、有効期限を設定する。          1. 正常終了の場合、生成したクレジットカード情報とHTTPステータスコード200を返却し、処理を終了する。&lt;br/&gt;     &amp;emsp;※クレジットカード番号についてはマスキング処理を行い、マスキング済みの値を返却する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCreditPanInformationPost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetCreditPanInformationResponse>;
  public getCreditPanInformationPost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetCreditPanInformationResponse>>;
  public getCreditPanInformationPost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetCreditPanInformationResponse>>;
  public getCreditPanInformationPost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/get-credit-pan-information`;
    return this.httpClient.request<GetCreditPanInformationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
